export default "__VITE_ASSET__CXF4fo6$__"